(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calma-header"]) return;
  try {
    

/* ============ SEARCH LOGIC: EXACT BLOG TITLE OR PRODUCTS ONLY ============ */
(function() {
  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/\s+/g, ' ')
      .trim();
  }

  window.calmaHeaderSearch = function(inputId) {
    var input = document.getElementById(inputId);
    var query = input ? input.value.trim() : '';
    if (!query) return;

    var productSearchUrl = '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(query);
    var articleSuggestUrl = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=article&resources[limit]=10&resources[options][fields]=title';

    fetch(articleSuggestUrl, { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) throw new Error('Search suggest failed');
        return response.json();
      })
      .then(function(data) {
        var articles = (((data || {}).resources || {}).results || {}).articles || [];
        var typedQuery = normalizeText(query);
        var exactArticle = articles.find(function(article) {
          return normalizeText(article.title) === typedQuery;
        });

        if (exactArticle && exactArticle.url) {
          window.location.href = exactArticle.url;
        } else {
          window.location.href = productSearchUrl;
        }
      })
      .catch(function() {
        window.location.href = productSearchUrl;
      });
  };
})();

class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = ['always','reduce-logo-size'].includes(this.getAttribute('data-sticky-type'));
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideOnScrollUp = () => (this.preventReveal = true);
    this.addEventListener('preventHeaderReveal', this.hideOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    new IntersectionObserver((entries, obs) => {
      this.headerBounds = entries[0].intersectionRect;
      obs.disconnect();
    }).observe(this.header);
  }
  onScroll() {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (st > this.currentScrollTop && st > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
    } else if (st < this.currentScrollTop && st > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (st <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = st;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky');
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky','animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate');
  }
}
customElements.define('sticky-header', StickyHeader);

/* ============ MOBILE DRAWER LOGIC ============ */
document.addEventListener('DOMContentLoaded', function() {
  const openBtn = document.getElementById('calma-open-drawer');
  const closeBtn = document.getElementById('calma-close-drawer');
  const drawer = document.getElementById('calma-mobile-drawer');
  const overlay = document.getElementById('calma-drawer-overlay');

  // Move drawer & overlay to end of body so they sit above
  // announcement bars, sticky headers, and any stacking contexts.
  if (drawer && drawer.parentNode !== document.body) {
    document.body.appendChild(drawer);
  }
  if (overlay && overlay.parentNode !== document.body) {
    document.body.appendChild(overlay);
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.classList.add('calma-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('calma-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // ESC key closes
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  // Accordion toggles (level 1 & 2)
  const toggles = drawer.querySelectorAll('.calma-drawer-toggle, .calma-drawer-toggle-inner');
  toggles.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const targetId = btn.getAttribute('data-target');
      const target = document.getElementById(targetId);
      if (!target) return;
      const isOpen = target.classList.contains('is-open');
      if (isOpen) {
        target.classList.remove('is-open');
        btn.classList.remove('is-active');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        target.classList.add('is-open');
        btn.classList.add('is-active');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Close drawer on resize to desktop
  window.addEventListener('resize', function() {
    if (window.innerWidth >= 990 && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });
});










/* ============ CART ICON PROTECTION ============ */
document.addEventListener('DOMContentLoaded', function() {
  
  function restoreCartIcon() {
    const cartIconWrap = document.querySelector('.calma-icons-wrap');
    if (!cartIconWrap) return;
    
    let cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;
    
    // Check agar Shopify ne default icon inject kar diya
    const hasCustomSVG = cartIcon.querySelector('svg path[d*="M6 2L3 6"]');
    if (!hasCustomSVG) {
      // Restore custom calma cart icon
      cartIcon.innerHTML = `
        <svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
          <line x1="3" y1="6" x2="21" y2="6"/>
          <path d="M16 10a4 4 0 0 1-8 0"/>
        </svg>`;
    }
    
    // Cart count update karo
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        let badge = cartIcon.querySelector('.calma-cart-count');
        if (cart.item_count > 0) {
          if (!badge) {
            badge = document.createElement('div');
            badge.className = 'calma-cart-count';
            badge.setAttribute('aria-hidden', 'true');
            cartIcon.appendChild(badge);
          }
          badge.textContent = Math.min(cart.item_count, 99);
        } else {
          if (badge) badge.remove();
        }
      });
  }

  // Shopify cart update events listen karo
  document.addEventListener('cart:updated', restoreCartIcon);
  document.addEventListener('cart:refresh', restoreCartIcon);
  
  // MutationObserver - agar DOM change ho toh detect karo
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (cartIcon) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          const hasCustomSVG = cartIcon.querySelector('svg path[d*="M6 2L3 6"]');
          if (!hasCustomSVG) {
            restoreCartIcon();
          }
        }
      });
    });
    observer.observe(cartIcon, { childList: true, subtree: true });
  }

  // Parent container bhi observe karo
  const iconsWrap = document.querySelector('.calma-icons-wrap');
  if (iconsWrap) {
    const parentObserver = new MutationObserver(function() {
      restoreCartIcon();
    });
    parentObserver.observe(iconsWrap, { childList: true, subtree: false });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

/* ============ SEARCH LOGIC: EXACT BLOG TITLE OR PRODUCTS ONLY ============ */
(function() {
  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/\s+/g, ' ')
      .trim();
  }

  window.calmaHeaderSearch = function(inputId) {
    var input = document.getElementById(inputId);
    var query = input ? input.value.trim() : '';
    if (!query) return;

    var productSearchUrl = '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(query);
    var articleSuggestUrl = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=article&resources[limit]=10&resources[options][fields]=title';

    fetch(articleSuggestUrl, { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) throw new Error('Search suggest failed');
        return response.json();
      })
      .then(function(data) {
        var articles = (((data || {}).resources || {}).results || {}).articles || [];
        var typedQuery = normalizeText(query);
        var exactArticle = articles.find(function(article) {
          return normalizeText(article.title) === typedQuery;
        });

        if (exactArticle && exactArticle.url) {
          window.location.href = exactArticle.url;
        } else {
          window.location.href = productSearchUrl;
        }
      })
      .catch(function() {
        window.location.href = productSearchUrl;
      });
  };
})();

class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = ['always','reduce-logo-size'].includes(this.getAttribute('data-sticky-type'));
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideOnScrollUp = () => (this.preventReveal = true);
    this.addEventListener('preventHeaderReveal', this.hideOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    new IntersectionObserver((entries, obs) => {
      this.headerBounds = entries[0].intersectionRect;
      obs.disconnect();
    }).observe(this.header);
  }
  onScroll() {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (st > this.currentScrollTop && st > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
    } else if (st < this.currentScrollTop && st > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (st <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = st;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky');
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky','animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate');
  }
}
customElements.define('sticky-header', StickyHeader);

/* ============ MOBILE DRAWER LOGIC ============ */
document.addEventListener('DOMContentLoaded', function() {
  const openBtn = document.getElementById('calma-open-drawer');
  const closeBtn = document.getElementById('calma-close-drawer');
  const drawer = document.getElementById('calma-mobile-drawer');
  const overlay = document.getElementById('calma-drawer-overlay');

  // Move drawer & overlay to end of body so they sit above
  // announcement bars, sticky headers, and any stacking contexts.
  if (drawer && drawer.parentNode !== document.body) {
    document.body.appendChild(drawer);
  }
  if (overlay && overlay.parentNode !== document.body) {
    document.body.appendChild(overlay);
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.classList.add('calma-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('calma-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // ESC key closes
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  // Accordion toggles (level 1 & 2)
  const toggles = drawer.querySelectorAll('.calma-drawer-toggle, .calma-drawer-toggle-inner');
  toggles.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const targetId = btn.getAttribute('data-target');
      const target = document.getElementById(targetId);
      if (!target) return;
      const isOpen = target.classList.contains('is-open');
      if (isOpen) {
        target.classList.remove('is-open');
        btn.classList.remove('is-active');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        target.classList.add('is-open');
        btn.classList.add('is-active');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Close drawer on resize to desktop
  window.addEventListener('resize', function() {
    if (window.innerWidth >= 990 && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });
});










/* ============ CART ICON PROTECTION ============ */
document.addEventListener('DOMContentLoaded', function() {
  
  function restoreCartIcon() {
    const cartIconWrap = document.querySelector('.calma-icons-wrap');
    if (!cartIconWrap) return;
    
    let cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;
    
    // Check agar Shopify ne default icon inject kar diya
    const hasCustomSVG = cartIcon.querySelector('svg path[d*="M6 2L3 6"]');
    if (!hasCustomSVG) {
      // Restore custom calma cart icon
      cartIcon.innerHTML = `
        <svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
          <line x1="3" y1="6" x2="21" y2="6"/>
          <path d="M16 10a4 4 0 0 1-8 0"/>
        </svg>`;
    }
    
    // Cart count update karo
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        let badge = cartIcon.querySelector('.calma-cart-count');
        if (cart.item_count > 0) {
          if (!badge) {
            badge = document.createElement('div');
            badge.className = 'calma-cart-count';
            badge.setAttribute('aria-hidden', 'true');
            cartIcon.appendChild(badge);
          }
          badge.textContent = Math.min(cart.item_count, 99);
        } else {
          if (badge) badge.remove();
        }
      });
  }

  // Shopify cart update events listen karo
  document.addEventListener('cart:updated', restoreCartIcon);
  document.addEventListener('cart:refresh', restoreCartIcon);
  
  // MutationObserver - agar DOM change ho toh detect karo
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (cartIcon) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          const hasCustomSVG = cartIcon.querySelector('svg path[d*="M6 2L3 6"]');
          if (!hasCustomSVG) {
            restoreCartIcon();
          }
        }
      });
    });
    observer.observe(cartIcon, { childList: true, subtree: true });
  }

  // Parent container bhi observe karo
  const iconsWrap = document.querySelector('.calma-icons-wrap');
  if (iconsWrap) {
    const parentObserver = new MutationObserver(function() {
      restoreCartIcon();
    });
    parentObserver.observe(iconsWrap, { childList: true, subtree: false });
  }
});

  } catch(e) { console.error(e); }
})();
})();
